// src/pages/dashboard/components/Panel.tsx
import type { ReactNode } from 'react'

interface PanelProps {
  children: ReactNode
  className?: string
  style?: React.CSSProperties
  pad?: number | string
  onClick?: () => void
  lift?: boolean
}

export default function Panel({ children, className = '', style = {}, pad = 20, onClick, lift = false }: PanelProps) {
  const padClass = pad === 20 ? 'p-5' : pad === 18 ? 'p-[18px]' : ''
  const padStyle = padClass ? {} : { padding: typeof pad === 'number' ? `${pad}px` : pad }

  return (
    <div
      onClick={onClick}
      className={`glass ${lift ? 'lift' : ''} rounded-[var(--r-lg)] ${padClass} ${className}`}
      style={{
        ...padStyle,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
